import { useEffect, useRef } from "react";
import QRCode from "qrcode";

const PcOnlyPage = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const siteUrl = window.location.origin + __BASE_PATH__;

  useEffect(() => {
    if (canvasRef.current) {
      QRCode.toCanvas(canvasRef.current, siteUrl, {
        width: 220,
        margin: 2,
        color: {
          dark: "#be185d",
          light: "#ffffff",
        },
      });
    }
  }, [siteUrl]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 via-rose-50 to-pink-100 px-4"
      style={{ fontFamily: "'Nunito', sans-serif" }}
    >
      <div className="w-full max-w-sm">
        {/* Card */}
        <div className="bg-white rounded-3xl overflow-hidden border border-pink-100">
          {/* Top gradient header */}
          <div className="bg-gradient-to-r from-pink-400 to-rose-400 px-6 pt-8 pb-6 text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
              <i className="ri-smartphone-line text-white text-3xl"></i>
            </div>
            <img
              src="https://public.readdy.ai/ai/img_res/db459360-20e7-4f18-828f-b6f77daa6c55.png"
              alt="Girls' Map"
              className="h-10 w-auto object-contain mx-auto mb-3 drop-shadow"
            />
            <h1 className="text-xl font-black text-white mb-1">
              スマートフォン専用サイトです
            </h1>
            <p className="text-pink-100 text-xs leading-relaxed">
              本サイトはスマートフォン専用となります。
            </p>
          </div>

          {/* Body */}
          <div className="px-6 py-6 text-center">
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              こちらのQRコードよりアクセスしてご利用下さい。
            </p>

            {/* QR Code */}
            <div className="inline-block bg-white rounded-2xl p-4 border-2 border-pink-200 mb-5">
              <canvas ref={canvasRef} className="block mx-auto" />
              <p className="text-xs text-gray-400 mt-2.5 flex items-center justify-center gap-1">
                <i className="ri-camera-line text-pink-300"></i>
                カメラでスキャンしてください
              </p>
            </div>

            {/* Steps */}
            <div className="flex flex-col gap-2.5 mb-5 text-left">
              {[
                { step: "1", text: "スマートフォンのカメラを起動" },
                { step: "2", text: "QRコードにカメラを向ける" },
                { step: "3", text: "表示されたリンクをタップ" },
              ].map((item) => (
                <div key={item.step} className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center bg-pink-100 rounded-full flex-shrink-0">
                    <span className="text-pink-500 text-xs font-black">{item.step}</span>
                  </div>
                  <p className="text-sm text-gray-600">{item.text}</p>
                </div>
              ))}
            </div>

            {/* URL display */}
            <div className="bg-pink-50 rounded-xl px-4 py-3 border border-pink-100">
              <p className="text-xs text-gray-400 mb-1">アクセスURL</p>
              <p className="text-xs text-pink-500 font-medium break-all">{siteUrl}</p>
            </div>
          </div>
        </div>

        {/* Brand footer */}
        <p className="text-center text-xs text-gray-400 mt-5">
          Girls&apos; Map &copy; {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default PcOnlyPage;
